/**
 * Utility class that launches an instance of the DownloadCsvDialog.
 */

import DownloadCsvDialog from './download-csv-dialog';
export default class DownloadCsvDialogLauncher {

  constructor(datasetsModel, selectedSitesModel, referenceSitesModel, referenceSitesHashModel,
              config) {

    // Cache references.
    this._datasetsModel = datasetsModel;
    this._selectedSitesModel = selectedSitesModel;
    this._referenceSitesModel = referenceSitesModel;
    this._referenceSitesHashModel = referenceSitesHashModel;
    this._config = config;

  }

  launch() {
    new DownloadCsvDialog({
      datasetsModel: this._datasetsModel,
      selectedSitesModel: this._selectedSitesModel,
      referenceSitesModel: this._referenceSitesModel,
      referenceSitesHashModel: this._referenceSitesHashModel,
      config: this._config
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/components/selected-sites-panel/dialogs/download-csv-dialog-launcher.js